import React from 'react';
import { motion } from 'framer-motion';
import { FaGithub, FaArrowRight, FaLinkedin, FaEnvelope, FaDownload } from 'react-icons/fa';
import ParticleLoader from '../animations/ParticleLoader';
import './Contact.css';

const EMAIL = 'geoara07@gmail.com';
const LINKEDIN = 'https://www.linkedin.com/in/george-arampatzis';
const GITHUB = 'https://github.com/justsubway';

const Contact = () => {
  return (
    <div className="contact" id="contact">
      <div className="contact-model">
        <ParticleLoader />
      </div>
      <div className="contact-cta">
        <p className="contact-pitch">
          Open to internships and junior full-stack / front-end roles.
          Prefer email or LinkedIn — I reply quickly.
        </p>
        <div className="contact-buttons">
          <motion.button
            className="contact-button github"
            onClick={() => window.open(GITHUB, '_blank')}
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
          >
            <FaGithub />
            <span>GitHub</span>
            <FaArrowRight className="arrow-icon" />
          </motion.button>

          <motion.button
            className="contact-button linkedin"
            onClick={() => window.open(LINKEDIN, '_blank')}
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
          >
            <FaLinkedin />
            <span>LinkedIn</span>
            <FaArrowRight className="arrow-icon" />
          </motion.button>

          <motion.button
            className="contact-button email"
            onClick={() => {
              window.location.href = `mailto:${EMAIL}`;
            }}
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
          >
            <FaEnvelope />
            <span>Email</span>
            <FaArrowRight className="arrow-icon" />
          </motion.button>

          <motion.a
            className="contact-button resume"
            href={process.env.PUBLIC_URL + '/George_Arampatzis.pdf'}
            download="George_Arampatzis_CV.pdf"
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
          >
            <FaDownload />
            <span>Resume</span>
            <FaArrowRight className="arrow-icon" />
          </motion.a>
        </div>
      </div>
    </div>
  );
};

export default Contact;
